var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedsYourAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FFB067",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2118 33.7333L18.2395 26.6083C17.6197 25.975 17.6197 24.9854 18.2395 24.3521L25.2118 17.2271C25.8316 16.5937 26.7999 16.5937 27.4197 17.2271L34.392 24.3521C35.0118 24.9854 35.0118 25.975 34.392 26.6083L27.4197 33.7333C26.7999 34.3667 25.7928 34.3667 25.2118 33.7333Z",
    fill: "#F49136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3667 28.9438C25.3667 28.825 25.4054 28.7063 25.4442 28.5875C25.4829 28.4688 25.5604 28.3896 25.6378 28.3105C25.7153 28.2313 25.8315 28.1521 25.9477 28.1125C26.0639 28.073 26.1801 28.0334 26.3351 28.0334C26.49 28.0334 26.6062 28.073 26.7224 28.1125C26.8386 28.1521 26.9548 28.2313 27.0323 28.3105C27.1098 28.3896 27.1872 28.4688 27.226 28.5875C27.2647 28.7063 27.3035 28.825 27.3035 28.9438C27.3035 29.0625 27.2647 29.1813 27.226 29.3C27.1872 29.4188 27.1098 29.498 27.0323 29.5771C26.9548 29.6563 26.8386 29.7355 26.7224 29.775C26.6062 29.8146 26.49 29.8542 26.3351 29.8542C26.1801 29.8542 26.0639 29.8146 25.9477 29.775C25.8315 29.7355 25.754 29.6563 25.6378 29.5771C25.5604 29.498 25.4829 29.4188 25.4442 29.3C25.4054 29.1813 25.3667 29.1021 25.3667 28.9438ZM26.9936 27.123H25.5991L25.4054 21.1459H27.1872L26.9936 27.123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedsYourAttention);
export default __webpack_public_path__ + "static/media/needsYourAttention.609815add731061fc16d8aa4e0e27fe9.svg";
export { ForwardRef as ReactComponent };